import {uniq} from 'lodash';
import set from 'lodash/fp/set';
import moment from 'moment';
import {categoriesList2FilterParams} from '../../misc/categoriesList2FilterParams';

export default function (state, action) {
    if (!state)
        state = {
            loaded: false,
            listed: [],
            filtered: [],
            disambiguation: null,
            categoryValues: {}, // Used to match username aliases
            categories: [], // Used for filters
            filterParams: {text: null, categories: null, connections: null},
            recommendedFilter: null,
        };

    switch (action.type) {
        case 'EVENT_PARTICIPANTS_LOADED':
            state = Object.assign({}, state, {
                fetchTime: moment(action.fetchTime),
                loaded: true,
                listed: action.participants,
                categoryValues: action.categoryValues || {},
                categories: action.categories || [],
                recommendedFilter: action.recommendedFilter,
            });
            break;
        case 'EVENT_PARTICIPANT_UPDATED':
            state = {
                ...state,
                listed: state.listed.map(participant =>
                    participant.participant_id == action.participant.participant_id
                        ? {
                              ...participant,
                              ...action.participant,
                          }
                        : participant
                ),
            };
            break;
        case 'UPDATE_USER':
            state = {
                ...state,
                listed: state.listed.map(participant => {
                    if (participant.user_id == action.userId) {
                        return {
                            ...participant,
                            ...action.user,
                        };
                    }
                    return participant;
                }),
            };
            break;
        case 'EVENT_PARTICIPANTS_DISAMBIGUATION':
            state = {
                ...state,
                disambiguation: action.matches ,
            };
            break;
        case 'EVENT_PARTICIPANTS_FILTER_BY_TEXT':
            state = set('filterParams.text', action.text, state);
            break;
        case 'EVENT_PARTICIPANTS_FILTER_BY_CATEGORIES':
            state = set('filterParams.categories', action.catFilter, state);
            break;
        case 'EVENT_PARTICIPANTS_FILTER_SET':
            state = set('filterParams', action.filterParams, state);
            break;
        case 'EVENT_PARTICIPANTS_FILTER_ADD_CATEGORY_VALUE':
            state = {
                ...state,
                filterParams: {
                    ...state.filterParams,
                    categories: {
                        ...state.filterParams.categories,
                        [action.catName]: uniq([...(state.filterParams.categories?.[action.catName] ?? []), action.optionValue]),
                    },
                },
            };
            break;
        case 'EVENT_PARTICIPANTS_FILTER_REMOVE_CATEGORY_VALUE':
            state = {
                ...state,
                filterParams: {
                    ...state.filterParams,
                    categories: {
                        ...state.filterParams.categories,
                        [action.catName]: (state.filterParams.categories?.[action.catName] ?? []).filter(value => value != action.optionValue),
                    },
                },
            };
            break;
        case 'EVENT_PARTICIPANTS_UPDATE_CATEGORIES':
            state = set(`categories`, action.categories, state);
            break;
        case 'EVENT_PARTICIPANTS_USE_RECOMMENDED':
            if (state.recommendedFilter) {
                state = {
                    ...state,
                    filterParams: categoriesList2FilterParams(state.recommendedFilter),
                };
            }
            break;
        case 'EVENT_PARTICIPANT_POKED':
            state = set(
                'listed',
                state.listed.map(p => {
                    if (p.participant_id == action.participantId) {
                        return set('can_poke', false, p);
                    }
                    return p;
                }),
                state
            );
            break;
        case 'SESSION_UPDATES':
            if (action.updates.online) {
                let hasChanges = false,
                    listed = state.listed.map(p => {
                        if (p.user_id) {
                            let newStatus = action.updates.online.find(userId => userId == p.user_id) ? 'online' : 'offline';
                            if (p.status != newStatus) {
                                hasChanges = true;
                                return {
                                    ...p,
                                    status: newStatus,
                                };
                            }
                        }
                        return p;
                    });
                if (hasChanges) {
                    state = {
                        ...state,
                        listed,
                    };
                }
            }
            break;
        case 'EVENT_PROGRAM_SELECTION_UPDATE':
            state = {
                ...state,
                listed: state.listed.map(p =>
                    p.user_id == action.userId
                        ? {
                              ...p,
                              program_selection: uniq(
                                  p.program_selection
                                      // remove deselected items
                                      .filter(id => !action.deselectedItems.includes(id))
                                      // add new items
                                      .concat(action.selectedItems)
                              ),
                          }
                        : p
                ),
            };
            break;
    }

    return state;
}
